import { render, staticRenderFns } from "./filter-pill.vue?vue&type=template&id=073bbe9b"
import script from "./filter-pill.vue?vue&type=script&lang=js"
export * from "./filter-pill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports